import { getPatientData } from "apis";
import { getLastVisit, getUpcomingVisit } from "../../utils/bridges/methods";
import {
  firebaseAppointmentToAppointment,
} from "../../utils/firestore-utils/firebase-appointment-to-offline-appointment";
import { Appointment, APPOINTMENT_STATUS, PatientOverview, PatientProfile, TFormData } from "@elixir/types";
import { AuthgoPatient } from "apis/src/aorta-go/get-patient-data";

export const FULL_GENDER_CHARS = {
    M: 'Male',
    F: 'Female',
    O: 'Other',
};

const regularAptValidUpcomingAptStatus = [
    APPOINTMENT_STATUS.BOOKED,
    APPOINTMENT_STATUS.CHECKED_IN,
    APPOINTMENT_STATUS.ONGOING,
  ];
  const followupAptValidUpcomingAptStatus = [
    APPOINTMENT_STATUS.INITIATED,
    APPOINTMENT_STATUS.RESERVED,
    APPOINTMENT_STATUS.PROVISIONAL_CANCELLED,
    ...regularAptValidUpcomingAptStatus,
  ];
  export function isValidUpcomingAppointment(
    apt: Pick<Appointment, 'status' | 'visit_type'>
  ): boolean {
    if (apt.visit_type === 'FLW') {
      return followupAptValidUpcomingAptStatus.includes(
        apt.status as APPOINTMENT_STATUS
      );
    }
  
    return regularAptValidUpcomingAptStatus.includes(
      apt.status as APPOINTMENT_STATUS
    );
  }

const getPatientOverview = async ({ patientId }: { patientId: string }): Promise<{patientOverview: PatientOverview, patient: AuthgoPatient} | undefined> => {
    try {
      const patient = await getPatientData(patientId);
      const patientprofile: PatientProfile = {
        at: patient.at,
        dob: patient.dob,
        "dob-valid": true,
        "health-ids": patient["health-ids"] || [],
        fln: patient.fln,
        fn: patient.fn,
        gen: FULL_GENDER_CHARS[patient.gen as keyof typeof FULL_GENDER_CHARS],
        "is-p": true,
        ln: patient.ln || "",
        mn: patient.mn || "",
        mobile: patient.mobile || "",
        oid: patient.oid,
        pic: null,
        uuid: patient.uuid || "",
        email: null,
        type: 3,
      };

      if (!patient) return;

      const links = patient.extras?.link;

      const [docs1, flwDocs1] = await Promise.allSettled([
        getLastVisit([patient.oid, ...(links || [])]),
        getUpcomingVisit([patient.oid, ...(links || [])]),
      ]);

      const docs = docs1.status === "fulfilled" ? docs1.value : undefined;
      const flwDocs =
        flwDocs1.status === "fulfilled" ? flwDocs1.value : undefined;

      const lastVisitDoc = docs?.docs?.[0];
      const followUpDoc = flwDocs?.docs?.[0];

      const lastVisitApt = lastVisitDoc?.id
        ? firebaseAppointmentToAppointment(
            lastVisitDoc?.id,
            lastVisitDoc,
            patientprofile,
            (patient.extras?.formData || []) as TFormData[]
          )
        : undefined;
      const followUpApt = followUpDoc?.id
        ? firebaseAppointmentToAppointment(
            followUpDoc?.id,
            followUpDoc,
            patientprofile,
            (patient.extras?.formData || []) as TFormData[]
          )
        : undefined;
          console.log({followUpApt})
      return {patientOverview:{
        last_visit: lastVisitApt as Appointment,
        upcoming_appointment: (followUpApt ? isValidUpcomingAppointment(followUpApt) ? followUpApt : undefined : undefined )as Appointment,
        patient: patientprofile,
        dues_pending: (() => {
          const payments = patient?.extras?.payments;
          if (typeof payments === "object" && payments !== null && typeof payments.dues === "number") {
            return payments.dues;
          }
          if (typeof payments === "number") {
            return payments;
          }
          return 0;
        })(),
      }, patient};
    } catch (err) {
        console.error(err);
    }
  };

export default getPatientOverview;
